import { AppConfig } from '../../App/App.types'
import { SET_APP_CONFIG } from './action_types'

export const setAppConfig = (appConfig: AppConfig) => {
  return {
    type: SET_APP_CONFIG,
    payload: appConfig
  }
}
